import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { isItemAllowed, useLiFi, useWidgetConfig } from '../providers';
import { useSettingsStoreContext } from '../stores';
export const useTools = () => {
    const lifi = useLiFi();
    const { bridges, exchanges } = useWidgetConfig();
    const settingsStoreContext = useSettingsStoreContext();
    const { data } = useQuery(['tools'], () => lifi.getTools(), {
        onSuccess(data) {
            const { initializeTools } = settingsStoreContext.getState();
            initializeTools('Bridges', data.bridges
                .filter((bridge) => isItemAllowed(bridge.key, bridges))
                .map((bridge) => bridge.key));
            initializeTools('Exchanges', data.exchanges
                .filter((exchange) => isItemAllowed(exchange.key, exchanges))
                .map((exchange) => exchange.key));
        },
        refetchInterval: 180000,
        staleTime: 180000,
    });
    const formattedTools = useMemo(() => ({
        bridges: data === null || data === void 0 ? void 0 : data.bridges.reduce((bridges, bridge) => {
            bridges[bridge.key] = bridge;
            return bridges;
        }, {}),
        exchanges: data === null || data === void 0 ? void 0 : data.exchanges.reduce((exchanges, exchange) => {
            exchanges[exchange.key] = exchange;
            return exchanges;
        }, {}),
    }), [data === null || data === void 0 ? void 0 : data.bridges, data === null || data === void 0 ? void 0 : data.exchanges]);
    return { tools: data, formattedTools };
};
